/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StarburstIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Starburst',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m18.1 3.325 2.52 7.087 6.793-3.229a.5.5 0 0 1 .666.666l-3.229 6.793 7.087 2.52a.5.5 0 0 1 0 .942l-7.087 2.52 3.229 6.793a.5.5 0 0 1-.666.666l-6.793-3.229-2.52 7.088a.5.5 0 0 1-.942 0l-2.52-7.087-6.789 3.229a.5.5 0 0 1-.666-.666l3.229-6.793L3.325 18.1a.5.5 0 0 1 0-.942l7.087-2.52-3.229-6.789a.5.5 0 0 1 .666-.666l6.793 3.229 2.52-7.087a.5.5 0 0 1 .938 0Z"
    />
  </svg>`;
};
